import { apiGet, apiPost, apiPatch } from "./client";
import type {
  IdealCustomerProfile,
  IdealCustomerProfileInput,
} from "@sales-ops-amplify/shared";

export async function listIcps(): Promise<{
  icps: IdealCustomerProfile[];
  activeIcpId?: string;
}> {
  return apiGet("/api/icp");
}

export async function getIcp(id: string): Promise<IdealCustomerProfile> {
  const res = await apiGet<{ icp: IdealCustomerProfile }>(`/api/icp/${id}`);
  return res.icp;
}

export async function createIcp(
  input: IdealCustomerProfileInput & { setActive?: boolean },
): Promise<IdealCustomerProfile> {
  const res = await apiPost<{ icp: IdealCustomerProfile }>("/api/icp", input);
  return res.icp;
}

export async function updateIcp(
  id: string,
  input: Partial<IdealCustomerProfileInput> & { setActive?: boolean },
): Promise<IdealCustomerProfile> {
  const res = await apiPatch<{ icp: IdealCustomerProfile }>(`/api/icp/${id}`, input);
  return res.icp;
}
